export const loadPermissions = {
    INVOICE: {
        key: 'Load.Invoice',
        name: 'View Invoice Data',
    }
}